<script>
	'use strict'

	import MptzHeadIcon from './MptzHeadIcon.svelte';
	import AppHeaderGrid from './AppHeaderGrid.svelte';
  import AppHeaderOptions from "./AppHeaderOptions.svelte";
	import BtnThemePalette from './BtnThemePalette.svelte';
</script>


<div class="flex-24">
  <MptzHeadIcon></MptzHeadIcon>
  <AppHeaderGrid></AppHeaderGrid>
</div>
<div class="flex-24">
  <AppHeaderOptions></AppHeaderOptions>
  <BtnThemePalette></BtnThemePalette>
</div>
